export default __webpack_public_path__ + "static/key-cf8e1fb01ce852d3653ec8838c9ff635.svg";